export default "__VITE_ASSET__42d84f24__"